"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateQueryGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useUpdateQueryGroup(id) {
    const { data, isLoading, error, put } = (0, core_ui_1.useApiPut)(`query-groups/${id}`);
    return {
        updatedQueryGroup: data,
        updating: isLoading,
        updateError: error,
        updateQueryGroup: put
    };
}
exports.useUpdateQueryGroup = useUpdateQueryGroup;
//# sourceMappingURL=useUpdateQueryGroup.js.map